import { parseMilliseconds } from './parseMilliseconds'

export function formatMilliseconds(milliseconds: number): string {
  const [ms, sec, min] = parseMilliseconds(milliseconds)

  return `${min}:${sec}.${ms}`
}
